// src/components/HeaderNavBar.jsx
import React, { useState } from "react";
import {
  MenuItem,
  List,
  ListItem,
  IconButton,
  Drawer,
  ListItemText,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Home,
  Info,
  Article,
  ContactMail,
  People,
  AddCircle,
  Menu as MenuIcon,
  Phone,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

function HeaderNavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDesktopMenu, setOpenDesktopMenu] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const toggleSubMenu = (id) => setOpenSubMenu(openSubMenu === id ? null : id);
  const toggleDesktopMenu = (e, id) => {
    setAnchorEl(e.currentTarget);
    setOpenDesktopMenu(openDesktopMenu === id ? null : id);
  };

  const navigationItems = [
    { id: 1, label: "Home", icon: <Home />, link: "/" },
    { id: 2, label: "Profiles", icon: <People />, link: "/profiles" },
    { id: 3, label: "Add Profile", icon: <AddCircle />, link: "/profile-input" },
    { id: 4, label: "About", icon: <Info />, link: "/about" },
    { id: 5, label: "Blog", icon: <Article />, link: "/blog" },
    { id: 6, label: "Contact", icon: <ContactMail />, link: "/contact-us" },
  ];

  const PhoneContact = () => (
    <Box className="phone-contact" sx={{ display: "flex", alignItems: "center", px: 2 }}>
      <Phone sx={{ mr: 1 }} />
      <Typography>+92 34 2526 2121</Typography>
    </Box>
  );

  // Desktop menu - with transparent background and top corners rounded only
  const desktopMenu = (
    <List className="desktop-nav-list" sx={{ display: "flex", gap: 1 }}>
      {navigationItems.map((item) => (
        <MenuItem
          key={item.id}
          component={Link}
          to={item.link}
          sx={{
            backgroundColor: "transparent",
            borderRadius: "8px 8px 0 0",
            "&:hover": {
              backgroundColor: "secondary.main",
              color: "primary.main",
              "& svg": {
                color: "primary.main",
              }
            }
          }}
        >
          {item.icon}
          <span style={{ marginLeft: 8 }}>{item.label}</span>
        </MenuItem>
      ))}
    </List>
  );

  // Mobile menu - primary text/icons, light primary hover background with secondary light text/icons
  const mobileMenu = (
    <>
      {navigationItems.map((item) => (
        <ListItem
          key={item.id}
          button
          component={Link}
          to={item.link}
          onClick={() => setMobileMenuOpen(false)}
          sx={{
            backgroundColor: "transparent",
            color: "primary.main",
            "& svg": {
              color: "primary.main",
            },
            "&:hover": {
              backgroundColor: "primary.light",
              color: `${theme.palette.secondary.light} !important`, // Force secondary light
              "& svg": {
                color: `${theme.palette.secondary.light} !important`, // Force secondary light for icons
              },
              "& .MuiListItemText-primary": {
                color: `${theme.palette.secondary.light} !important`, // Force for ListItemText
              }
            }
          }}
        >
          {item.icon}
          <ListItemText
            primary={item.label}
            sx={{ ml: 1 }}
            primaryTypographyProps={{
              sx: {
                color: "inherit", // This will inherit the color from parent
              }
            }}
          />
        </ListItem>
      ))}
    </>
  );

  return (
    <Box
      className="navbar-container"
      sx={{
        width: "100%",
        backgroundColor: "transparent",
      }}
    >
      <Box
        className="navbar"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          backgroundColor: "transparent",
        }}
      >
        {!isMobile ? (
          <Box className="desktop-navbar">{desktopMenu}</Box>
        ) : (
          <>
            <PhoneContact />
            <IconButton
              onClick={toggleMobileMenu}
              sx={{
                backgroundColor: "transparent",
              }}
            >
              <MenuIcon />
            </IconButton>
          </>
        )}
      </Box>

      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={toggleMobileMenu}
        PaperProps={{
          sx: {
            backgroundColor: "secondary.light",
            width: { xs: 150, sm: 175 },
          }
        }}
      >
        <List sx={{ width: "100%" }}>{mobileMenu}</List>
      </Drawer>
    </Box>
  );
}

export default HeaderNavBar;